import {Chip, Box} from '@mui/material'

import {ChipsToggleOption} from '../types'

type CardChipsToggleProps<TOptionValue extends string> = {
  options: ChipsToggleOption<TOptionValue>[]
  value: TOptionValue
  onChange: (selected: TOptionValue) => void
}

export const CardChipsToggle = <TOptionValue extends string>({
  options,
  value,
  onChange
}: CardChipsToggleProps<TOptionValue>) => {
  return (
    <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
      {options.map((option) => (
        <Chip
          key={option.value}
          label={option.label}
          icon={option.icon}
          clickable
          color={option.value === value ? 'primary' : 'default'}
          onClick={(event) => {
            event.stopPropagation()
            event.preventDefault()
            onChange(option.value)
          }}
          size="small"
        />
      ))}
    </Box>
  )
}
